module.exports = __webpack_public_path__ + "static/img/bcg1.5d7b0e2c.webp";